import type { PropsWithChildren } from 'react';
import { useContext } from 'react';

import { Space, TextButton, WithTooltip } from '@procurify/ui'
import { IconAttention } from '@procurify/ui'
import { noop } from 'lodash'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { SaveFilterManagerContext } from '../../SavedFilterManagerContext'

export interface ISavedFilterManagerSaveButtonProps {
  onClick?: () => void
  invalidFiltersTooltipText?: string
}

export const SavedFilterManagerSaveButton = ({
  onClick = noop,
  invalidFiltersTooltipText,
}: PropsWithChildren<ISavedFilterManagerSaveButtonProps>) => {
  const intl = useProcurifyIntl()

  const { hasFilters, hasValidFilters, saveFilters } = useContext(
    SaveFilterManagerContext
  )

  return (
    <WithTooltip isDisabled={hasValidFilters} title={invalidFiltersTooltipText}>
      <WithTooltip.Wrapper>
        <Space direction='horizontal' size='small' align='center'>
          <TextButton
            disabled={!hasValidFilters || !hasFilters}
            onClick={() => {
              onClick()
              saveFilters()
            }}
          >
            {intl.formatMessage(messages.saveFiltersButtonText)}
          </TextButton>
          {!hasValidFilters && <IconAttention fontSize={12} />}
        </Space>
      </WithTooltip.Wrapper>
    </WithTooltip>
  )
}
